enum BankingIntegrations {
    ClearBank = 'CLEARBANK',
    Swisscom = 'SWISSCOM',
}
export default BankingIntegrations